var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TreeSelect',{ref:"treeSelect",attrs:{"props":_vm.props,"options":_vm.departmentData,"accordion":_vm.isAccordion,"value":_vm.valueId},on:{"getValue":function($event){return _vm.getValue($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }